import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import RoundedButton from '../buttons/Rounded';

import styles from '../../../styles/blocks/link.module.scss';

const propTypes = {
    title: PropTypes.string,
    link: PropTypes.shape({
        external: PropTypes.bool,
        url: PropTypes.string,
        label: PropTypes.string,
    }),
    linkColor: PropTypes.string,
    isContainer: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    title: false,
    link: null,
    linkColor: null,
    isContainer: false,
    className: null,
};

const CardsBlock = ({ title, link, linkColor, isContainer, className }) => {
    const { external: externalLink, url: linkUrl, label: linkLabel } = link || {};

    const onClick = useCallback(() => {
        if (!externalLink) {
            window.scroll({ top: 0 });
        }
    }, [externalLink]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                    },
                ])}
            >
                {link !== null && linkUrl !== null ? (
                    <div className={styles.linkContainer}>
                        <RoundedButton
                            className={styles.link}
                            backgroundColor={linkColor}
                            href={linkUrl}
                            external={externalLink}
                            onClick={onClick}
                        >
                            {linkLabel !== null ? (
                                linkLabel
                            ) : (
                                <FormattedMessage
                                    defaultMessage="View {title}"
                                    values={{ title }}
                                />
                            )}
                        </RoundedButton>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

CardsBlock.propTypes = propTypes;
CardsBlock.defaultProps = defaultProps;

export default CardsBlock;
